export default __webpack_public_path__ + "static/media/BDO_PERSONAL.690459a4.svg";